import React from 'react';

import Tag from 'elements/Tags/Tag/Tag';
import DraggableTag from 'elements/Tags/DraggableTags/DraggableTag/DraggableTag';
import FilterTag from 'elements/Tags/FiltersTag/FilterTag/FilterTag';
import ToggleTag from 'elements/Tags/FiltersTag/ToggleTag/ToggleTag';

/* eslint-disable react/prop-types */
export const Standard = ({ icon = {}, secondary = false, withClose, large, small }) => (
  <Tag name="Standard Tag" secondary={secondary} icon={icon.name && icon} withClose={withClose} small={small} large={large} />
);

export const Draggable = () => (
  <DraggableTag name="Draggable Tag" />
);

export const Filter = ({ status, icon = {}, white }) => (
  <FilterTag name="Filter Tag" status={status} icon={icon.name && icon} white={white} />
);

export const Toggle = ({ white }) => (
  <ToggleTag white={white} tags={{left: 'Filters Left', center: 'Filters Center', right: 'Filters Right'}} />
);

/* eslint-enable react/prop-types */


// WEBPACK FOOTER //
// ./src/containers/elements/Tags/constants/tagsLayouts.js